import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
    state: () => ({
        authenticated: null, // null | true | false
    }),

    getters: {
        isAuthenticated: (state) => state.authenticated,
    },

    actions: {
        setAuthenticated(value) {
            this.authenticated = value;
        },
    },
});